import RulesModule from 'diagram-js/lib/features/rules';

import StudioRules from './studioRules';

export default {
  __depends__: [RulesModule],
  __init__: ['studioRules'],
  studioRules: ['type', StudioRules]
};
